import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getInvoiceNotConfirmed } from '../../../../../lib/api/dashboard';
import EnhacedBox from '../../../../../lib/designSystem/Box';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import CustomPieChart from '../../../../../lib/designSystem/PieChart';

const InvoicesNotConfirmedNumber: React.FC = () => {
  const dispatch = useDispatch();
  const [invoicesPieChart, setInvoicesPieChart] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRelations = async () => {
      setLoading(true);
      const relations = await getInvoiceNotConfirmed(dispatch);
      setInvoicesPieChart(relations.pieChart);
      setLoading(false);
    };
    void fetchRelations();
  }, []);

  const handleClick = () => {
    window.location.href = `/home/notConfirmed`;
  };

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhacedBox>
        <Typography>Facturas por confirmar</Typography>
        <CustomPieChart onClick={handleClick} data={invoicesPieChart} />
      </EnhacedBox>
    </div>
  );
};

export default InvoicesNotConfirmedNumber;
